// extracted by css-extract-rspack-plugin
export default {"PopoverTrigger":"fk4tF"};